import { render } from "./ExpiredHygieneCert.vue?vue&type=template&id=18947d10&scoped=true"
import script from "./ExpiredHygieneCert.vue?vue&type=script&lang=js"
export * from "./ExpiredHygieneCert.vue?vue&type=script&lang=js"

import "./ExpiredHygieneCert.vue?vue&type=style&index=0&id=18947d10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18947d10"]])

export default __exports__